/**
 * Service to manage session expired modal state
 * Prevents multiple alerts from showing simultaneously
 */

type SessionExpiredCallback = (message?: string) => void;

class SessionExpiredService {
  private callbacks: Set<SessionExpiredCallback> = new Set();
  private isShowing = false;

  /**
   * Register a callback to show the session expired modal
   */
  onSessionExpired(callback: SessionExpiredCallback): () => void {
    this.callbacks.add(callback);
    // Return unsubscribe function
    return () => {
      this.callbacks.delete(callback);
    };
  }

  /**
   * Show the session expired modal (only if not already showing)
   */
  showSessionExpired(message?: string): void {
    // Prevent duplicate alerts
    if (this.isShowing) {
      return;
    }

    this.isShowing = true;

    // Notify all registered callbacks
    this.callbacks.forEach((callback) => {
      try {
        callback(message);
      } catch (error) {
        console.error('Error in session expired callback:', error);
      }
    });
  }

  /**
   * Hide the session expired modal
   */
  hideSessionExpired(): void {
    this.isShowing = false;
  }

  /**
   * Check if modal is currently showing
   */
  getIsShowing(): boolean {
    return this.isShowing;
  }
}

// Export singleton instance
export const sessionExpiredService = new SessionExpiredService();

